import { dependentKeyCompat } from '@ember/object/compat';

import Model, { attr, belongsTo, hasMany } from '@warp-drive/legacy/model';

import {
  buildValidations,
  validator,
} from 'umg-ember-backend/utils/validations';

const Validations = buildValidations({
  category: [validator('belongs-to'), validator('presence', true)],
});

export default class ProductElementModel extends Model.extend(Validations) {
  @attr('string') name;
  @attr('number', { defaultValue: 1 }) order;

  // CMS fields
  @attr('number', { defaultValue: 2 }) cmsState;

  // Meta fields
  @attr cmsCreated;
  @attr cmsDeleted;
  @attr cmsLocktime;
  @attr cmsModified;
  @attr() cmsHistory;
  @belongsTo('user', { async: true, inverse: null }) cmsOwnerId;
  @belongsTo('user', { async: true, inverse: null }) cmsCreatorId;
  @belongsTo('user', { async: true, inverse: null }) cmsLockerId;
  @belongsTo('user', { async: true, inverse: null }) cmsModifierId;

  // Relation
  @belongsTo('product', { async: true, inverse: null }) product;
  @belongsTo('category', { async: true, inverse: null }) category;
  @hasMany('product-track', { async: true, inverse: null }) productTracks;

  // Getter and setter
  get displayHeadline() {
    return this.categoryName;
  }

  @dependentKeyCompat
  get categoryName() {
    return this.category?.get('name');
  }

  get displayLabel() {
    return `${this.order}. ${this.categoryName} - ${this.id}`;
  }
}
